export const ADMIN_ROUTE_PATH = {
  ORDER_HISTORY: '/administration/orders/history',
  APPROVALS: '/administration/approvals/content',
  CONTENT_PROVIDERS: '/administration/approvals/license',
  ASSIGN: '/administration/assign',

  ASSIGNMENT_GROUPS: '/administration/assignment-group',
  ASSIGNMENT_GROUP: '/administration/assignment-group/:id/:name/*',
  NEW_ASSIGNMENT_GROUP: '/administration/assignment-group/new/*',

  JOURNEYS: '/administration/journeys',
  JOURNEY_CSV_IMPORT: '/administration/journeys/:journeyId/import-learners',

  PEOPLE: '/administration/people',

  USERS: '/administration/people/users',
  USER: '/administration/people/users/user/:id',
  USERS_CSV_IMPORT: '/administration/people/users/import',

  TEAMS: '/administration/people/teams',
  TEAM: '/administration/people/teams/team/:id/*',
  TEAM_USERS: '/administration/people/teams/team/:id/users',
  TEAM_SUB_TEAMS: '/administration/people/teams/team/:id/subTeams',

  CATALOG: '/administration/catalog',
  COURSE_NEW: '/administration/catalog/course/new',
  COURSE: '/administration/catalog/course/:id',
  LEARNING: '/administration/catalog/:learningType/:learningId/*',
  LEARNING_NEW: '/administration/catalog/:learningType/new/*',

  COURSES_V2: '/administration/catalog/courses',
  COURSES_V2_INSIGHTS: '/administration/catalog/learning/:learningURN/insights',
  PRACTICAL_ASSESSMENTS: '/administration/catalog/assessments',

  COLLECTION: '/administration/learning-collection/*',
  COLLECTION_ID: '/administration/learning-collection/:id/*',
  COLLECTION_NEW: '/administration/learning-collection/new/*',
  COLLECTION_PREVIEW: '/administration/learning-collection/:collectionId/:collectionName/preview',

  COLLECTIONS_V2: '/administration/collections',
  COLLECTION_V2_INSIGHTS: '/administration/collections/:id/insights',
  COLLECTION_V2_EDIT: '/administration/collections/:id/edit',
  COLLECTION_V2_NEW: '/administration/collections/new',
  COLLECTION_V2_PREVIEW: '/administration/collections/:collectionId/:collectionName/preview',
};

export const ADMIN_ROUTE_RELATIVE_PATH = {
  ORDER_HISTORY: 'orders/history',
  APPROVALS: 'approvals/*',
  APPROVALS_CONTENT: 'content',
  CONTENT_PROVIDERS: 'license',
  ASSIGN: 'assign',

  ASSIGNMENT_GROUPS: 'assignment-group',
  ASSIGNMENT_GROUP: 'assignment-group/:id/:name/*',
  NEW_ASSIGNMENT_GROUP: 'assignment-group/new/*',

  USERS: 'users',
  USER: 'users/user/:id',
  USERS_CSV_IMPORT: 'users/import',

  TEAMS: 'teams/*',
  TEAM: 'teams/team/:id/*',
  TEAM_USERS: 'users',
  TEAM_SUB_TEAMS: 'subTeams',

  CATALOG: 'catalog/*',
  LEARNING: ':learningType/:learningId/*',
  LEARNING_NEW: ':learningType/new/*',
  LEARNING_INSIGHTS: 'learning/:learningURN/insights',
  LEARNING_ACTIVITY_INSIGHTS: 'learning/:learningURN/activity/:activityId/insights',

  COURSE_NEW: 'course/new/*',
  COURSE: 'course/:id/*',
  COURSE_INSIGHTS: 'insights',
  QUIZ_INSIGHTS: 'insights/:activityId',

  COURSES_V2: 'courses/:learningId/:name/*',
  PRACTICAL_ASSESSMENT: 'assessments/:learningId/:name/*',
  LIVE_EVENT: 'live-event/:learningId/*',
  JOURNEYS: 'journeys',
  JOURNEY: ':journeyId/*',
  JOURNEY_CSV_IMPORT: 'import-learners',
  JOURNEY_EDIT: 'edit',
  JOURNEY_EDIT_CERTIFICATE: 'edit-certificate',
  JOURNEY_EDIT_LEARNINGS: 'edit-learnings/*',
  JOURNEY_EDIT_LEARNINGS_SECTION: 'sections/:sectionId',
  JOURNEY_PUBLISH: 'publish',
  JOURNEY_INSIGHTS: 'insights',
  JOURNEY_LEARNING_INSIGHTS: 'learning/:learningURN/insights',
  JOURNEY_LEARNING_INSIGHTS_V2: 'learning/:learningURN/insights',
  JOURNEY_LEARNING_ACTIVITY_INSIGHTS_V2: 'learning/:learningURN/activity/:activityId/insights',

  COLLECTION: 'learning-collection/*',
  COLLECTION_ID: 'learning-collection/:id/*',
  COLLECTION_NEW: 'learning-collection/new/*',
  COLLECTION_PREVIEW: 'learning-collection/:collectionId/:collectionName/preview',

  COLLECTIONS_V2: 'collections',
  COLLECTION_V2: ':id/*',
  COLLECTION_V2_INSIGHTS: 'insights/*',
  COLLECTION_V2_EDIT: 'edit/*',
  COLLECTION_V2_NEW: 'new/*',
  COLLECTION_V2_PREVIEW: ':collectionId/:collectionName/preview',
};
